import { render, staticRenderFns } from "./ManualExpensesModal.vue?vue&type=template&id=28d5a0dd&"
import script from "./ManualExpensesModal.vue?vue&type=script&lang=js&"
export * from "./ManualExpensesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports